import React from 'react';
import { Link, withRouter } from "react-router-dom";
import * as queryString from 'query-string';
import * as Tools from "../../../helpers/Tools";
import { logUI } from '../../../api/andyliticsApi';
import OpenScheduleButton from "../../care/OpenScheduleButton";
import { map } from 'lodash';
import { gaAddToCart } from '../../../api/gaLoging';
import { translateText } from '../../../helpers/data';
import { withTranslation } from 'react-i18next';

const ServiceLocationSlots = ({ loc, location, isMammogram, buttonText, enableFluVaccineSchedulingWorkflow, scheduleCampaignReferrer, isMammogramMapPinView, selectedIndex, totalLocations, t, translate}) => {
    const [addToCart, setAddToCard] = React.useState(true);
    const [position, setPosition] = React.useState((typeof selectedIndex === 'number' && selectedIndex >= 0) ? (selectedIndex + 1) : 0);
    const params = location.search ? queryString.parse(location.search) : {};
    const { bypassProxyAndInfo = false } = params;
    const twoDText = translateText(translate, "2D Screen", t);
    const threeDText = translateText(translate, "3D Screen", t);
    const screenText = ' ' + translateText(translate, "Screen", t);
    const twoDTextMobile = "2D";
    const threeDTextMobile = "3D";
    let twoDVisitType = false;
    let threeDVisitType = false;
    const moreUrl = enableFluVaccineSchedulingWorkflow ? `services/fluvaccine/schedule/${loc.openSchedules && loc.openSchedules.providerId}/OpenSchedule/${loc.openSchedules && loc.openSchedules.uniqueVisitTypeIds ? loc.openSchedules.uniqueVisitTypeIds : ""}/${loc.epicDepartmentId}` : isMammogram ? `services/mammogram/schedule/${loc.openSchedules && loc.openSchedules.providerId}/OpenSchedule/${loc.openSchedules && loc.openSchedules.uniqueVisitTypeIds ? loc.openSchedules.uniqueVisitTypeIds : ""}/${loc.epicDepartmentId}` : `/schedule/${loc.openSchedules && loc.openSchedules.providerId}/OpenSchedule/${loc.openSchedules && loc.openSchedules.dateAndTimes.length && loc.openSchedules.dateAndTimes[0].times.length ? loc.openSchedules.dateAndTimes[0].times[0].visitTypeId : ""}/${loc.epicDepartmentId}`;
    const scheduleCampaignActivity = scheduleCampaignReferrer ? { scheduleCampaignReferrer: scheduleCampaignReferrer } : {};

    for (let count = 0; count < loc.openSchedules.dateAndTimes.length; count++) {
        if (loc.openSchedules.dateAndTimes[count] && loc.openSchedules.dateAndTimes[count].displayLabel === twoDText || loc.openSchedules.dateAndTimes[count] && loc.openSchedules.dateAndTimes[count].visitTypeId === window.serverData.data.mammographyVisitTypeId) {
            twoDVisitType = true;
        }
        if (loc.openSchedules.dateAndTimes[count] && loc.openSchedules.dateAndTimes[count].displayLabel === threeDText || loc.openSchedules.dateAndTimes[count] && loc.openSchedules.dateAndTimes[count].visitTypeId === window.serverData.data.mammography3DVisitTypeId) {
            threeDVisitType = true;
        }

    }
    function get2Dand3D() {
        let items = arrange2Dand3DData(loc.openSchedules.dateAndTimes);
        let rows = [];
        let twoDimensionItem = {};
        let threeDimensionItem = {};
        let twoDimensionItemKey = 0;
        let threeDimensionItemKey = 0;
        let locDateAndTimes = loc && loc.openSchedules && loc.openSchedules.dateAndTimes.length;
        for (let count = 0; count < locDateAndTimes; count++) {
            twoDimensionItem = items[count];
            twoDimensionItemKey = count
            count = count + 1;
            threeDimensionItem = items[count];
            threeDimensionItemKey = count;

            if (twoDimensionItem !== undefined || threeDimensionItem !== undefined) {
                rows.push(
                    <div className="row" key={twoDimensionItemKey + twoDimensionItemKey}>
                        <div className="col">
                            <OpenScheduleButton npi={loc.openSchedules.providerId} scheduleData={twoDimensionItem} key={twoDimensionItemKey} dayString={twoDimensionItem && twoDimensionItem.dayString} dateString={twoDimensionItem && twoDimensionItem.dateString} isMammogram={isMammogram} translate={translate} bypassProxyAndInfo={bypassProxyAndInfo} scheduleCampaignReferrer={scheduleCampaignReferrer} />
                        </div>
                        <div className="col">
                            <OpenScheduleButton npi={loc.openSchedules.providerId} scheduleData={threeDimensionItem} key={threeDimensionItemKey} dayString={threeDimensionItem && threeDimensionItem.dayString} dateString={threeDimensionItem && threeDimensionItem.dateString} isMammogram={isMammogram} translate={translate} bypassProxyAndInfo={bypassProxyAndInfo} scheduleCampaignReferrer={scheduleCampaignReferrer} />
                        </div>
                    </div>
                );
            }

        }
        return rows;
    }

    function arrange2Dand3DData(items) {
        let twoDArray = [];
        let threeDArray = [];
        let twoDimensionCount = 0;
        let threeDimensionCount = 0;
        let finalArray = []
        for (let count = 0; count < loc.openSchedules.dateAndTimes.length; count++) {
            if (items[count].displayLabel === twoDText || loc.openSchedules.dateAndTimes[count].visitTypeId === window.serverData.data.mammographyVisitTypeId) {
                twoDArray.push(items[count]);
                twoDimensionCount = twoDimensionCount + 1;
            }

            if (items[count].displayLabel === threeDText || loc.openSchedules.dateAndTimes[count].visitTypeId === window.serverData.data.mammography3DVisitTypeId) {
                threeDArray.push(items[count]);
                threeDimensionCount = threeDimensionCount + 1;
            }
        }

        for (let i = 0; i < 3; i++) {
            if (twoDArray[i]) {
                finalArray.push(twoDArray[i]);
            } else {
                finalArray.push({});
            }
            if (threeDArray[i]) {
                finalArray.push(threeDArray[i]);
            } else {
                finalArray.push({});
            }
        }

        return finalArray;
    }
    const onBookNowClick = () => {
        logUI(`MBHWeb.UI.ServiceLocationSlots.BookNow.Clicked`, new Date(), Tools.getURLPath(), scheduleCampaignActivity);
        if (addToCart && enableFluVaccineSchedulingWorkflow) {
            const list = "Find Care Page";
            const category = "Open Scheduling";
            const eventType = "addToCart";
            const patientStatus = 'Existing Patient';
            const brand = 'Flu Vaccine';
            gaAddToCart(eventType, loc.openSchedules.providerId, loc.locationName, position, list, category, patientStatus, brand);
            setAddToCard(false)
        }
    }
    return (
        <div className="col-12 item-appt-options-container item-appt-options-visit-container">
            <div className="item-times-container">
                {(twoDVisitType && !threeDVisitType) || (!twoDVisitType && threeDVisitType) && isMammogram ?
                    <div className="map-heading">
                        <div className="row item-appt-list-heading">
                            <div className="col-sm item-appt-map-heading item-appt-map-heading-one">
                                {twoDVisitType && <><span className="mobile-screen-text">{twoDTextMobile}</span><span className="desktop-screen-text">{translateText(translate, twoDText, t)}</span></>}
                                {threeDVisitType && <><span className="mobile-screen-text">{threeDTextMobile}</span><span className="desktop-screen-text">{translateText(translate, threeDText, t)}</span></>}
                            </div>
                        </div>

                        <div className="appt-time-list appt-time-one-list">
                            {map(loc.openSchedules.dateAndTimes, (item, index) =>
                                index < 3 &&
                                <div className="row" key={index}>
                                    <div className="col">
                                            <OpenScheduleButton npi={loc.openSchedules.providerId} scheduleData={item} dayString={item.dayString} dateString={item.dateString}
                                                key={index} isMammogram={isMammogram} translate={translate} bypassProxyAndInfo={bypassProxyAndInfo} scheduleCampaignReferrer={scheduleCampaignReferrer}
                                            />
                                    </div>
                                </div>)}
                        </div>
                    </div>
                    : isMammogram && twoDVisitType && threeDVisitType ?
                        <div className="map-heading">
                            <div className="row item-appt-list-heading">
                                <div className="col-sm item-appt-map-heading"><span className="mobile-screen-text">{twoDTextMobile}</span><span className="desktop-screen-text">{translateText(translate, twoDText, t)}</span></div>
                                <div className="col-sm item-appt-map-heading item-3d-heading"><span className="mobile-screen-text">{threeDTextMobile}</span><span className="desktop-screen-text">{translateText(translate, threeDText, t)}</span></div>
                            </div>
                            <div className="appt-time-list">
                                {get2Dand3D()}
                            </div>
                        </div> :
                        !enableFluVaccineSchedulingWorkflow && <div className="appt-time-list">
                            {map(loc.openSchedules.dateAndTimes[0].times, (item, index) =>
                                index < 3 && <OpenScheduleButton npi={loc.openSchedules.providerId} scheduleData={item} dayString={item.dayString} key={index} bypassProxyAndInfo={bypassProxyAndInfo} scheduleCampaignReferrer={scheduleCampaignReferrer} />
                            )}
                        </div>
                }

                {enableFluVaccineSchedulingWorkflow &&
                    <div className="map-heading">
                        <div className="appt-time-list appt-time-one-list">
                            {map(loc.openSchedules.dateAndTimes, (item, index) =>
                                index < 3 &&
                                <div className="row" key={index}>
                                    <div className="col">
                                        <OpenScheduleButton npi={loc.openSchedules.providerId} scheduleData={item} dayString={item.dayString} dateString={item.dateString} key={index} isMammogram={isMammogram} translate={translate} bypassProxyAndInfo={bypassProxyAndInfo} scheduleCampaignReferrer={scheduleCampaignReferrer} />
                                    </div>
                                </div>)}
                        </div>
                    </div>
                }
                <div className="appt-time-more row">
                    <Link to={{
                        pathname: moreUrl, search: `bypassProxyAndInfo=${bypassProxyAndInfo}`,
                        state: { scheduleCampaignReferrer: scheduleCampaignReferrer, loc: loc, selectedIndex: position }
                    }}
                        className="btn btn-primary"
                        onClick={() => {
                            // logUI(`MBHWeb.UI.ServiceLocationSlots.BookNow.Clicked`, new Date(), Tools.getURLPath(), scheduleCampaignActivity)
                            onBookNowClick()
                        }}
                    >
                        <span className="desktop-label">{buttonText}</span>
                        <span className="mobile-label--mapCard">{buttonText}</span>
                    </Link>
                </div>
            </div>
        </div>
    )
}

export default withRouter(withTranslation() (ServiceLocationSlots));